import React from "react";
import { Brain, Cable, LayoutTemplate, CloudCog, Maximize2, Mic } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
const benefits = [{
  title: "Experiencia impulsada por IA",
  description: "Seguimiento inteligente de video y audio para reuniones más naturales y fluidas, adaptándose dinámicamente a los participantes.",
  icon: Brain
}, {
  title: "Conectividad de un solo cable",
  description: "Cableado CAT5e simplificado que reduce el desorden en la mesa de conferencias y acelera significativamente el tiempo de instalación.",
  icon: Cable
}, {
  title: "Interfaz de Teams consistente",
  description: "Experiencia nativa y familiar de Microsoft Teams en todos los dispositivos, garantizando una adopción rápida por parte del usuario.",
  icon: LayoutTemplate
}, {
  title: "Gestión remota centralizada",
  description: "Control total, monitorización y mantenimiento simplificado de todos sus dispositivos a través de la plataforma YMCS.",
  icon: CloudCog
}, {
  title: "Escalabilidad total",
  description: "Soluciones de hardware perfectamente adaptables para cualquier entorno, desde pequeñas salas de reunión hasta espacios extra grandes.",
  icon: Maximize2
}, {
  title: "Excelencia en audio",
  description: "Tecnología avanzada de micrófonos de formación de haces SkySound para una captura de voz nítida y sin interferencias.",
  icon: Mic
}];
export default function BeneficiosClaveYealink() {
  return <section id="beneficios-clave-yealink" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold font-default text-foreground mb-4">
            Beneficios Clave de Yealink
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Descubra cómo nuestras soluciones transforman sus espacios de reunión con tecnología innovadora y diseño centrado en el usuario.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {benefits.map((benefit, i) => {
          const Icon = benefit.icon;
          return <Card key={i} data-index={i} className="border border-border bg-card hover:shadow-md transition-all duration-300 h-full flex flex-col">
                <CardHeader className="flex flex-col items-center text-center pb-4 pt-8">
                  <div className="p-4 rounded-lg bg-muted/50 mb-4">
                    <Icon className="w-8 h-8 text-chart-3" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="font-default text-xl text-foreground">
                    {benefit.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-grow flex items-start justify-center pb-8">
                  <p className="text-muted-foreground text-center leading-relaxed">
                    {benefit.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}